// provides Node's Buffer API to the browser
export let Buffer = require("buffer").Buffer;
